import { render, staticRenderFns } from "./HostItemNum.vue?vue&type=template&id=55a6e184&"
import script from "./HostItemNum.vue?vue&type=script&lang=js&"
export * from "./HostItemNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports